<template>
  <div class="">
    <Card class=" h-100">
      <template #title> Ürün Satış </template>
      <template #content>

        <div class="grid flex justify-content-center flex-wrap">
          <div class="col-7">

            <IslemYapiliyor v-if="IslemYapiliyor" />

            <div class="grid">
              <!-- 2. Kolon -->
              <div class="col-6">
                <div class="grid">
                  <div class="col-12">
                    <label for="Urun" class="font-bold block">Ürün</label>
                    <Select v-model="pUrun" :options="UrunListesi" optionLabel="Ad" placeholder="Seçin" filter
                      class="text-base text-color w-full" :invalid="this.Valid.pUrun" @change="UrunChange" />
                  </div>
                  <div class="col-6">
                    <label for="SatisMiktar" class="font-bold block">Satış Miktar</label>
                    <InputNumber id="SatisMiktar" v-model="SatisMiktar" inputId="integeronly" :minFractionDigits="2"
                      fluid class="text-base text-color w-full" :invalid="this.Valid.SatisMiktar" />
                  </div>
                  <div class="col-6">
                    <label for="Birim" class="font-bold block">Birim</label>
                    <InputText id="Birim" type="text" v-model="Birim" class="text-base text-color w-full" disabled />
                  </div>
                  <div class="col-6">
                    <label for="SatisTutar" class="font-bold block">Satış Tutarı</label>
                    <InputNumber id="SatisTutar" v-model="SatisTutar" inputId="integeronly" :minFractionDigits="2" fluid
                      mode="currency" currency="TRY" class="text-base text-color w-full"
                      :invalid="this.Valid.SatisTutar" />
                  </div>
                </div>
              </div>

              <!-- 2. Kolon -->
              <div class="col-6">
                <div class="grid">
                  <div class="col-12">
                    <label for="Musteri" class="font-bold block">Müşteri</label>
                    <Select v-model="pMusteri" :options="MusteriListesi" optionLabel="Isim" placeholder="Seçin" filter
                      :invalid="this.Valid.pMusteri" class="text-base text-color w-full" />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <label for="Aciklama" class="font-bold block"> Açıklama</label>
                <Textarea id="Aciklama" v-model="Aciklama" rows="2" cols="30" class="text-base text-color w-full"
                  :invalid="this.Valid.Aciklama" />
              </div>
              <div class="col-12 flex justify-content-end flex-wrap">

                <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small" severity="success"
                  @click="this.handleClick()" autofocus :disabled="IslemYapiliyor" v-if="!IslemYapiliyor" />
              </div>
            </div>


          </div>
        </div>

      </template>
    </Card>
  </div>
</template>

<script>
import GlobalServis from "../../../../services/GlobalServis";

export default {
  data() {
    return {
      IslemYapiliyor: false,

      UrunListesi: [],
      MusteriListesi: [],

      //----
      pUrun: "",
      pMusteri: 0,
      SatisMiktar: 0,
      Birim: "",
      Aciklama: "",
      SatisTutar: "",

      //--------------
      // Validation Elements
      Valid: {
        pUrun: false,
        pMusteri: false,
        SatisMiktar: false,
        Birim: false,
        Aciklama: false,
        SatisTutar: false
      }
    };
  },
  methods: {
    handleClick() {
      if (this._FormCheck()) { /* this.ResetForm(); */ return; }
      this.IslemYapiliyor = true;

      let data = {
        pUrun: this.pUrun.Urun_rowid,
        pMusteri: this.pMusteri.Musteri_rowid,
        pHareketTanim: "",
        Aciklama: this.Aciklama,
        Miktar: this.SatisMiktar,
        Tutar: this.SatisTutar
      };

      GlobalServis.GlobalServis("POST", "SetUrunSatis", data).then((res) => {
        if (res.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Başarılı",
            detail: "Urun satışı yapılmıştır.",
            life: 3000,
          });
          this.ResetForm();
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "warn",
            summary: "Uyarı",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
        }
      }).then(() => {
        this.IslemYapiliyor = false;
      });
    },
    ResetForm() {
      this.UrunListesi = [];
      this.MusteriListesi = [];

      this.pUrun = "";
      this.pMusteri = 0;
      this.SatisMiktar = 0;
      this.Birim = "";
      this.Aciklama = "";
      this.SatisTutar = "";

      this.Valid.pUrun = false;
      this.Valid.pMusteri = false;
      this.Valid.SatisMiktar = false;
      this.Valid.Birim = false;
      this.Valid.pDepo = false;
      this.Valid.Aciklama = false;

      this._GetUrun();
      this._GetMusteri();

    },
    _FormCheck() {
      let Check = false;
      if (this.pUrun === "") {
        this.Valid.pUrun = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Urun seçiniz.", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.pUrun = false; Check = false; }

      if (this.pMusteri === 0) {
        this.Valid.pMusteri = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Müşteri seçiniz.", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.pMusteri = false; Check = false; }

      if (this.SatisMiktar === 0) {
        this.Valid.SatisMiktar = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "SatisMiktar giriniz.", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.SatisMiktar = false; Check = false; }

      if (this.SatisTutar === 0) {
        this.Valid.SatisTutar = true;
        this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Satış tutarını giriniz.", life: 3000, });
        Check = true;
        return Check;
      } else { this.Valid.SatisTutar = false; Check = false; }

    },
    UrunChange(e) {
      this.Birim = e.value.BirimAd
      // this.ToplamStokMiktar = e.value.Miktar
    },
    _GetUrun() {
      GlobalServis.GlobalServis("GET", "GetUrunBilgi_Aktif", "").then((res) => {
        if (res.status == 200) {
          this.UrunListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _GetMusteri() {
      GlobalServis.GlobalServis("GET", "GetMusteri_Sade", "").then((res) => {
        if (res.status == 200) {
          this.MusteriListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
  },
  mounted() {
    this.IslemYapiliyor = true;
    this._GetUrun();
    this._GetMusteri();
    this.IslemYapiliyor = false;
  },
  components: {
  },

};
</script>